import { Loader2 } from "lucide-react";
import { cn } from "~/shared/lib/utils";

type SpinnerProps = {
  /** Accessible label for screen readers. Leave undefined for purely decorative use. */
  label?: string;
  /** Size preset. `sm` = 14px, `md` = 16px, `lg` = 24px. Defaults to `md`. */
  size?: "sm" | "md" | "lg";
  className?: string;
};

const sizeMap = {
  sm: "size-3.5",
  md: "size-4",
  lg: "size-6",
} as const;

/**
 * Shared auth spinner — replaces hand-rolled inline `<svg>` animations
 * scattered across passkey / MFA flows. Uses the `Loader2` lucide icon
 * under the hood so stroke widths + geometry match other icons.
 */
export function Spinner({ label, size = "md", className }: SpinnerProps) {
  return (
    <Loader2
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? "status" : undefined}
      className={cn("animate-spin", sizeMap[size], className)}
    />
  );
}
